/**
 * @generated SignedSource<<f6ace34e27f93879e9f5ae3286a3554e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespUnavailableHeroCarousel_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespHeroCarousel_viewer">;
  readonly " $fragmentType": "PdpRespUnavailableHeroCarousel_viewer";
};
export type PdpRespUnavailableHeroCarousel_viewer$key = {
  readonly " $data"?: PdpRespUnavailableHeroCarousel_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespUnavailableHeroCarousel_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespUnavailableHeroCarousel_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespHeroCarousel_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "2982a2c0df2cd4cba7dc1dd6f35e5c73";

export default node;
